import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';
import { useIntl } from '@grandvisionhq/state';
import { formatPrice } from '@grandvisionhq/utils';

const BestPrice = (_param)=>{
    var { amount , currencyCode , className , isCentAmount =false , isFeatureEnabled , discountedPrice , originalPrice  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "amount",
        "currencyCode",
        "className",
        "isCentAmount",
        "isFeatureEnabled",
        "discountedPrice",
        "originalPrice"
    ]);
    const { getFormattedLabel , locale  } = useIntl();
    if (!isFeatureEnabled) {
        return null;
    }
    if (!amount) {
        return null;
    }
    if (!currencyCode) {
        return null;
    }
    /*
    Show recent lowest price only if:
      1. The feature is enabled
      2. The (product) variant has a defined product attribute bestPrice
      3. The bestPrice is different from the discounted price if there is a discounted price
      4. The bestPrice is different from the product original price if there is no discounted price
  */ const shouldShowBestPrice = isFeatureEnabled && amount && (discountedPrice && amount !== discountedPrice || !discountedPrice && amount !== originalPrice);
    if (!shouldShowBestPrice) {
        return null;
    }
    return /*#__PURE__*/ React__default.createElement("div", swcHelpers.extends({
        "data-t": "best-price",
        className: classnames('best-price', className)
    }, rest), getFormattedLabel('products.recentLowestPrice', {
        labelData: {
            recentLowestPrice: formatPrice({
                locale,
                value: amount,
                currency: currencyCode,
                isCentAmount
            })
        }
    }));
};
var BestPrice$1 = BestPrice;

export { BestPrice$1 as default };
//# sourceMappingURL=BestPrice.js.map
